import { types } from "./action";

const initialState = {
  loaded: false,
  loading: false,
  error: null,
  list: null,
  successResponse: null,
  errorResponse: null,
  totalPages: null,
  filterList: null,
  changeLog: null,
  changeLogLoading: false,
  changeLogLoaded: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_EPG_LIST: {
      return {
        ...state,
        loading: true,
        loaded: false,
        list: [],
      };
    }
    case types.FETCH_EPG_LIST_SUCCESS: {
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action?.payload?.result,
        total: action?.payload?.total,
        totalPages: action?.payload?.totalPages,
        filterList: action?.payload?.filterList,
      };
    }
    case types.FETCH_EPG_LIST_FAILED: {
      return {
        ...state,
        loading: false,
        loaded: true,
        errorResponse: action.payload,
        list: null,
      };
    }
    case types.FETCH_MORE_EPG_LIST_SUCCESS: {
      return {
        ...state,
        list: [...(state.list || []), ...(action?.payload?.data?.result || [])],
      };
    }
    case types.FETCH_MORE_EPG_LIST_FAILED: {
      return {
        ...state,
        error: action.payload,
      };
    }
    case types.EPG_CHANNEL_ADD: {
      return {
        ...state,
        successResponse: null,
        errorResponse: null,
      };
    }
    case types.EPG_CHANNEL_ADD_SUCCESS: {
      return {
        ...state,
        successResponse: action.payload,
        errorResponse: null,
      };
    }
    case types.EPG_CHANNEL_ADD_FAILED: {
      return {
        ...state,
        successResponse: null,
        errorResponse: action.payload,
      };
    }
    case types.UPDATE_EPG_LIST_ITEM: {
      return {
        ...state,
        successResponse: null,
        errorResponse: null,
      };
    }
    case types.UPDATE_EPG_LIST_ITEM_SUCCESS: {
      return {
        ...state,
        successResponse: action.payload,
        errorResponse: null,
      };
    }
    case types.UPDATE_EPG_LIST_ITEM_FAILED: {
      return {
        ...state,
        successResponse: null,
        errorResponse: action.payload,
      };
    }
    case types.DELETE_EPG_CHANNEL: {
      return {
        ...state,
        successResponse: null,
        errorResponse: null,
      };
    }
    case types.DELETE_EPG_CHANNEL_SUCCESS: {
      return {
        ...state,
        successResponse: action.payload,
        errorResponse: null,
      };
    }
    case types.DELETE_EPG_CHANNEL_FAILED: {
      return {
        ...state,
        successResponse: null,
        errorResponse: action.payload,
      };
    }
    case types.CLEAR_RESPONSES: {
      return {
        ...state,
        successResponse: null,
        errorResponse: null,
      };
    }
    case types.FETCH_EPG_CHANNEL_CHANGE_LOG: {
      return {
        ...state,
        changeLog: action.payload,
        changeLogLoading: true,
        changeLogLoaded: false,
      };
    }
    case types.FETCH_EPG_CHANNEL_CHANGE_LOG_SUCCESS: {
      return {
        ...state,
        changeLog: action.payload,
        errorResponse: null,
        changeLogLoading: false,
        changeLogLoaded: true,
      };
    }
    case types.FETCH_EPG_CHANNEL_CHANGE_LOG_FAILED: {
      return {
        ...state,
        changeLog: [],
        errorResponse: action.payload,
        changeLogLoading: false,
        changeLogLoaded: true,
      };
    }
    default:
      return state;
  }
}
